import { isBrowser } from 'ws-scripts/modules/environment';

/**
 * helper that lets you know if you're on a small screen (one that is under 768 in width)
 *
 * @param viewportWidth
 * @returns {boolean}
 */
export const getIsSmallScreen = (viewportWidth) => {
	return viewportWidth < 768;
};

export const getSpotIconSize = (deviceType) => {
	const screen =
		deviceType === 'DESKTOP' && isBrowser && window.screen?.width > 1200
			? 'HIRES'
			: deviceType;
	return (
		{
			HIRES: '104',
			DESKTOP: '96',
			MOBILE: '80'
		}[screen] ?? '96'
	);
};
